var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackageBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M29.3333 24V10.2092C29.3333 8.79467 28.7714 7.43812 27.7712 6.43792L25.5621 4.22878C24.5619 3.22859 23.2053 2.66669 21.7908 2.66669H10.2091C8.79461 2.66669 7.43806 3.22859 6.43786 4.22878L4.22872 6.43792C3.22853 7.43812 2.66663 8.79467 2.66663 10.2092V24C2.66663 26.9455 5.05444 29.3334 7.99996 29.3334H24C26.9455 29.3334 29.3333 26.9455 29.3333 24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7908 2.66669H10.2091C8.79462 2.66669 7.43807 3.22859 6.43787 4.22878L4.22873 6.43792C3.4374 7.22926 2.92042 8.24367 2.73901 9.33335H29.2609C29.0795 8.24367 28.5625 7.22926 27.7712 6.43792L25.5621 4.22878C24.5619 3.22859 23.2053 2.66669 21.7908 2.66669Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.33337H20V17.3334L16 14.6667L12 17.3334V9.33337Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageBox);
export default __webpack_public_path__ + "static/media/package_box.6568d0f7877274147d33b9a595a13cec.svg";
export { ForwardRef as ReactComponent };